export default "__VITE_ASSET__I1zEnAw4__"